var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01068 2.13153C5.14513 1.88873 5.40268 1.74004 5.68018 1.74499L14.0343 1.89416C14.2974 1.89886 14.5388 2.04113 14.6704 2.26904L19.0305 9.8209C19.162 10.0488 19.1645 10.329 19.037 10.5592L14.9892 17.8687C14.8547 18.1115 14.5972 18.2602 14.3197 18.2552L5.96562 18.106C5.70249 18.1013 5.46107 17.9591 5.32949 17.7312L0.969418 10.1793C0.837833 9.95138 0.835331 9.67118 0.962827 9.44095L5.01068 2.13153Z",
    stroke: "#2B2B35",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.2237959de760c6da779e7c8039b6a969.svg";
export { ForwardRef as ReactComponent };